import request from "@/utils/request";

// 获取区域树
export function getRegion() {
  return request({
    url: "/permission/areaTree",
    method: "post",
  });
}
// 根据IP获取位置
export function getLocationByIp(data) {
  return request({
    url: "/permission/get-by-ip",
    method: "post",
    data,
  });
}
